import { render, staticRenderFns } from "./OperacionesTab.vue?vue&type=template&id=2a9128e7&"
import script from "./OperacionesTab.vue?vue&type=script&lang=js&"
export * from "./OperacionesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports